// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1bHFC","notes":"Notes_notes__ZksQR"};